module.exports = __webpack_public_path__ + "selwebee_spt_costumebox-ENGLISH-fbd471883ae9861e9cfbdd791eda42c3.png";